import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "../";
import { PropertyCopyOptionResource } from "./property-copy-option-resource";
import { RelationCopyOptionResource } from "./relation-copy-option-resource";

/**
 * Defines the entity copy options resource.
 */
@JsonObject()
export class EntityCopyOptionsResource {
    /**
     * Gets or sets the copy profile identifier.
     */
    @JsonProperty("copy_profile_identifier")
    copyProfileIdentifier: Nullable<string>;

    /**
     * Gets or sets the copy profile id.
     */
    @JsonProperty("copy_profile_id")
    copyProfileId: Nullable<number>;

    /**
     * Gets or sets the culture load option.
     */
    @JsonProperty("destination_entity_id")
    destinationEntityId: Nullable<number>;

    /**
     * Gets or sets the relation copy options.
     */
    @JsonProperty("relation_copy_options")
    @JsonElementType(RelationCopyOptionResource)
    relationCopyOptions: Nullable<Array<RelationCopyOptionResource>>;

    /**
     * Gets or sets the property copy options.
     */
    @JsonProperty("property_copy_options")
    @JsonElementType(PropertyCopyOptionResource)
    propertyCopyOptions: Nullable<Array<PropertyCopyOptionResource>>;
}
